import { DOMAIN_TYPE_USE_MSG_SOUND } from '../../../consts';
export var getUseMsgSound = function (state) {
    return state.domain[DOMAIN_TYPE_USE_MSG_SOUND];
};
